var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.classes,attrs:{"href":_vm.href,"target":_vm.target}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }